// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorFallback_container__34AQq","subContainer":"ErrorFallback_subContainer__3muki","alert":"ErrorFallback_alert__30Pek"};